'use client'

import React,{useState,useEffect} from "react";
import { useGlobalContext } from "../context/provider";
import HeaderMobile from "../Responsive/header/headerMobile";
import HeaderDesktop from "../Responsive/header/headerDesktop";
import { AxiosGetData } from "../context/axiosfunction";
import { usePathname } from "next/navigation";
import { getFreeCampaignAvailability } from '@/lib/getFreeCampaignAvailability';

export default  function Header() {
    const {theme,setTheme,screen,API,headers,Token,privateKey} = useGlobalContext()
    const [login,setlogin]=useState('no')
    const [noti,setNoti] = useState(0)
    const pathname = usePathname();
    const [hasFreeCampaigns, setHasFreeCampaigns] = useState(false);

    useEffect(() => {
        let active = true;
        let controller;
        let inFlight = false;
        let lastChecked = 0;
        const check = async () => {
            if (inFlight || Date.now() - lastChecked < 60000) return;
            inFlight = true;
            lastChecked = Date.now();
            controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 10000);
            try {
                const available = await getFreeCampaignAvailability(API, controller.signal);
                if (active) setHasFreeCampaigns(available);
            } finally {
                inFlight = false;
                clearTimeout(timeout);
            }
        };
        check();
        const refresh = () => {
            if (document.visibilityState === 'visible') check();
        };
        const interval = setInterval(refresh, 60000);
        window.addEventListener('focus', refresh);
        return () => {
            active = false;
            clearInterval(interval);
            window.removeEventListener('focus', refresh);
            controller?.abort();
        };
    }, [API]);

    useEffect(()=>{
            // console.log(';P');
            // console.log(Token);

        const GetNoti = async() => {
            
            const response = await AxiosGetData(API,'/api/checkauthent/get_alarm_noti',headers,privateKey)
            // console.log(response);
            
            setNoti(response);
            
        } 
        if(Token) {
            
            GetNoti()
        }
    },[pathname])


    return(
        <>
            {screen === 'mobile' ? (
                <HeaderMobile noti={noti} hasFreeCampaigns={hasFreeCampaigns} />
            ) : (
                <HeaderDesktop noti={noti} hasFreeCampaigns={hasFreeCampaigns} />
            )}
        </>
    )
}
